module.exports = ".mat-column-active,\n.mat-column-progress,\n.mat-column-color {\n  display: flex;\n  text-align: center; }\n"